import React, { Component } from "react";
import {
  Paper,
  withStyles,
  Grid,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from "@material-ui/core";
import GetInfo from "../../../API/Companies/ShowAllPersonal";
import toasType from "../../../API/CallUtils/tostyNotification";
import Add from "./DialogAddPersonal";
import AddIcon from "@material-ui/icons/Add";
import Delete from "../../../API/Companies/DeletePersonal";
import DeleteIcon from "@material-ui/icons/Delete";
const styles = (theme) => ({
  Initial: {
    width: "100%",
  },
  Paper: {
    width: "100%",
    minHeight: "200px",
    borderRadius: "0px 0px 10px 10px",
    //padding: "1%",
    //marginTop: "1%",
  },
  Subtitle: {
    width: "100%",
    borderRadius: "10px 10px 0px 0px",
    backgroundColor: "#ad1d21",
    color: "rgb(247, 244, 244)",
    boxShadow:
      "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
  },
  AddCandidate: {
    width: "100%",
    height: "100%",
    backgroundColor: "rgb(99, 159, 191,0.2)",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "rgb(30, 160, 230)",
    "&:hover": {
      backgroundColor: "rgb(99, 159, 191,0.5)",
    },
  },
  marginL: {
    marginLeft: "5px",
    width: "28%",
  },
  Margin: {
    padding: "5px",
  },
});

class TablePadron extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DialogEdit: false,
      Delegados: [],
      Comicionados: [],
      Secretarios: [],
      type: "",
    };
  }
  componentDidMount = async () => {
    if (this.props.uuid) {
      this.GetInfo();
    }
  };
  Edit = (name) => {
    this.setState({
      DialogEdit: !this.state.DialogEdit,
      type: name ? name : "",
    });
  };
  GetInfo = async () => {
    try {
      const SeccionsShow = await GetInfo(this.props.id);
      if (SeccionsShow) {
        console.log(SeccionsShow);
        const delgados = SeccionsShow.assemblyMembers.filter(
          (member) => member.UserProfile.title === "Delegado"
        );
        const Comicionados = SeccionsShow.assemblyMembers.filter(
          (member) => member.UserProfile.title === "Comicionado"
        );
        const Secretarios = SeccionsShow.assemblyMembers.filter(
          (member) => member.UserProfile.title === "Secretario"
        );
        this.setState({
          Delegados: delgados,
          Comicionados: Comicionados,
          Secretarios: Secretarios,
        });
      } else {
        //toasType.error("Error en la petición al servidor");
        console.log(SeccionsShow);
      }
    } catch (e) {
      console.log(e);
      toasType.error("Error en la red / Error de conexión");
    }
  };

  Delete = async (uuid) => {
    try {
      const DeleteCommite = await Delete(uuid);
      if (DeleteCommite) {
        toasType.success("Elemento eliminado");
        this.GetInfo();
      } else {
        //toasType.error("Error en la petición al servidor");
        console.log(DeleteCommite);
      }
    } catch (e) {
      console.log(e);
    }
  };
  reload = async () => {
    this.GetInfo();
  };

  render() {
    const { classes } = this.props;
    return (
      <Grid className={classes.Initial}>
        <Grid container className={classes.Initial} spacing={1}>
          <Grid
            container
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            xl={4}
            className={classes.Initial}
          >
            <Typography
              align="Center"
              variant="h5"
              component="p"
              className={classes.Subtitle}
            >
              Delegados
            </Typography>
            <Paper className={classes.Paper}>
              {this.state.Delegados.length > 0 ? (
                <>
                  <Table
                    size="small"
                    aria-label="a dense table"
                    className={classes.TableCompany}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Nombre</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Teléfono</TableCell>

                        <TableCell>Municipio</TableCell>
                        <TableCell>Eliminar</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className={classes.TableCompany}>
                      {this.state.Delegados.map((Asesor) => {
                        return (
                          <React.Fragment>
                            <TableRow key={Asesor.Uuid}>
                              <TableCell component="th" scope="row">
                                {Asesor.UserProfile.name}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.UserProfile.otherMail}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.UserProfile.personalPhone}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.UserProfile.city}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Button
                                  color="secondary"
                                  onClick={this.Delete.bind(this, Asesor.uuid)}
                                >
                                  <DeleteIcon />
                                </Button>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      })}
                    </TableBody>
                  </Table>
                  <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    alignItems="center"
                    className={classes.Margin}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={this.Edit.bind(this, "Delegado")}
                    >
                      <AddIcon />
                    </Button>
                  </Grid>
                </>
              ) : (
                <Button
                  className={classes.AddCandidate}
                  onClick={this.Edit.bind(this, "Delegado")}
                >
                  Sin Miembros registrados
                </Button>
              )}
            </Paper>
          </Grid>
          <Grid
            container
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            xl={4}
            className={classes.Initial}
          >
            <Typography
              align="Center"
              variant="h5"
              component="p"
              className={classes.Subtitle}
            >
              Comisionados
            </Typography>
            <Paper className={classes.Paper}>
              {this.state.Comicionados.length > 0 ? (
                <>
                  <Table
                    size="small"
                    aria-label="a dense table"
                    className={classes.TableCompany}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Nombre</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Teléfono</TableCell>

                        <TableCell>Municipio</TableCell>
                        <TableCell>Eliminar</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className={classes.TableCompany}>
                      {this.state.Comicionados.map((Asesor) => {
                        return (
                          <React.Fragment>
                            <TableRow key={Asesor.Uuid}>
                              <TableCell component="th" scope="row">
                                {Asesor.UserProfile.name}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.UserProfile.otherMail}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.UserProfile.personalPhone}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                municipio
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Button
                                  color="secondary"
                                  onClick={this.Delete.bind(this, Asesor.uuid)}
                                >
                                  <DeleteIcon />
                                </Button>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      })}
                    </TableBody>
                  </Table>
                  <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    alignItems="center"
                    className={classes.Margin}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={this.Edit.bind(this, "Comicionado")}
                    >
                      <AddIcon />
                    </Button>
                  </Grid>
                </>
              ) : (
                <Button
                  className={classes.AddCandidate}
                  onClick={this.Edit.bind(this, "Comicionado")}
                >
                  Sin Miembros registrados
                </Button>
              )}
            </Paper>
          </Grid>
          <Grid
            container
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            xl={4}
            className={classes.Initial}
          >
            <Typography
              align="Center"
              variant="h5"
              component="p"
              className={classes.Subtitle}
            >
              Secretarios Generales
            </Typography>
            <Paper className={classes.Paper}>
              {this.state.Secretarios.length > 0 ? (
                <>
                  <Table
                    size="small"
                    aria-label="a dense table"
                    className={classes.TableCompany}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Nombre</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Teléfono</TableCell>

                        <TableCell>Municipio</TableCell>
                        <TableCell>Eliminar</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className={classes.TableCompany}>
                      {this.state.Secretarios.map((Asesor) => {
                        return (
                          <React.Fragment>
                            <TableRow key={Asesor.Uuid}>
                              <TableCell component="th" scope="row">
                                {Asesor.UserProfile.name}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.UserProfile.otherMail}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.UserProfile.personalPhone}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                municipio
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Button
                                  color="secondary"
                                  onClick={this.Delete.bind(this, Asesor.uuid)}
                                >
                                  <DeleteIcon />
                                </Button>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      })}
                    </TableBody>
                  </Table>
                  <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    alignItems="center"
                    className={classes.Margin}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={this.Edit.bind(this, "Secretario")}
                    >
                      <AddIcon />
                    </Button>
                  </Grid>
                </>
              ) : (
                <Button
                  className={classes.AddCandidate}
                  onClick={this.Edit.bind(this, "Secretario")}
                >
                  Sin Miembros registrados
                </Button>
              )}
            </Paper>
          </Grid>
        </Grid>
        {this.state.DialogEdit
          ? [
              <Add
                CompanieUuid={this.props.uuid}
                id={this.props.id}
                DialogOpen={this.state.DialogEdit}
                DialogClose={this.Edit}
                type={this.state.type}
                Refresh={this.reload}
              />,
            ]
          : []}
      </Grid>
    );
  }
}

export default withStyles(styles)(TablePadron);
